import React, { useState, useEffect } from "react";
import axios from '../../common/axiosInstance';
import { useNavigate } from "react-router-dom";
import AuthLayout from "../../components/layout/auth-layout";
import { useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import animationData from "../../components/lottie/animation.json";
import Lottie from "lottie-react";
import { _security } from "../../common/constants";

function VerifyLink() {

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  const token = searchParams.get("token");

  const notifyError = (message) =>
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  const verifyLink = async (token) => {
    setLoading(true);

    const response = await axios.post('/verifylink', { token: token }).then(
      response => {
        notifySuccess(response.data.message);
        setLoading(false);
        setTimeout(() => {
          navigate("/launch");
        }, 1000);
      }
    ).catch(error => {
      if (error.response.status === 400) {
        notifyError(error.response.data.message);
      }
    });


  };

  useEffect(() => {
    verifyLink(token);
  }, []);

  return (
    <>
      {loading ? (
        <div className="lottie-wrapper page-wrapper">
          <Lottie animationData={animationData} loop={true} />
        </div>
      ) : (
        <AuthLayout>
          <ToastContainer />
        </AuthLayout>
      )}
    </>
  );

}

export default VerifyLink;
